import React, { useEffect, useRef, useState } from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import { usePrevious } from 'src/hooks/use_previous'

import Polaris from 'src/lib/Polaris'
import Image from 'src/components/image/dynamic'
import Item from './item'

import * as styles from './index.module.scss'


const Keyvisual = () => {

    const fadeDuration = 1200
    const zoomDuration = 7500

    const [height, setHeight] = useState(`100%`)
    const [current, setCurrent] = useState(0)
    const [animated, setAnimated] = useState(false)
    const [wrapStyles, setWrapStyles] = useState([])
    const [backStyles, setBackStyles] = useState([])
    const [itemStyles, setItemStyles] = useState([])
    const [dataShows, setDataShows] = useState([])

    const timer = useRef(null)

    const prevIndex = usePrevious(current)

    const data = useStaticQuery(graphql`
        query {
            arrangement: allWpArrangement(limit: 1) {
                nodes {
                    custom {
                        keyvisual {
                            ... on WpArticle {
                                custom {
									slug, type, url, title, lead, datetime
                                    visualPc { ...Image1920 }
                                    visualSp { ...Image1920 }
                                }
                                tags: articleTags {
                                    nodes { name }
                                }
                            }
                        }
                    }
                }
            }
        }
    `)

    const visuals = data.arrangement.nodes[0].custom.keyvisual

    const change = (index) => {
        setCurrent(index % visuals.length)
    }

    const nextSlide = () => {
        timer.current = setTimeout(() => change(current + 1), zoomDuration - fadeDuration)
    }

    const click = (index) => {
        if (!animated) change(index)
    }


    useEffect(() => {
        clearTimeout(timer.current)

        const startOpacity = prevIndex === undefined ? 1 : 0

        const _wrapStyles = visuals.map((_, i) => {
            if (i === current) {
                return { zIndex: 2, opacity: startOpacity, transition: `` }
            } else if (i === prevIndex) {
                return { ...wrapStyles[i], zIndex: 1 }
            } else {
                return { ...wrapStyles[i], zIndex: 0 }
            }
        })
        const _backStyles = visuals.map((_, i) => {
            if (i === current) {
                return { transform: `scale(1.0)`, transition: `` }
            } else {
                return { ...backStyles[i] }
            }
        })
        setWrapStyles(_wrapStyles)
        setBackStyles(_backStyles)
        setAnimated(true)

        timer.current = setTimeout(() => {
            const _wrapStyles = visuals.map((_, i) => {
                if (i === current) {
                    return { zIndex: 2, opacity: 1, transition: `opacity ${fadeDuration}ms ease-in` }
                } else if (i === prevIndex) {
                    return { ...wrapStyles[i], zIndex: 1 }
                } else {
                    return { ...wrapStyles[i], zIndex: 0 }
                }
            })
            const _backStyles = visuals.map((_, i) => {
                if (i === current) {
                    return { transform: `scale(1.07)`, transition: `transform ${zoomDuration}ms linear` }
                } else {
                    return { ...backStyles[i] }
                }
            })
            const _itemStyles = visuals.map((_, i) => {
                if (i === current) {
                    return { zIndex: 1, pointerEvents: `` }
                } else {
                    return { zIndex: 0, pointerEvents: `none` }
                }
            })
            const _dataShows = visuals.map((_, i) => {
                return i === current
            })
            setWrapStyles(_wrapStyles)
            setBackStyles(_backStyles)
            setItemStyles(_itemStyles)
            setDataShows(_dataShows)
            nextSlide()
        }, 20)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current])

    useEffect(() => {
        const resizeID = Polaris.util.onResize(() => {
            setHeight(document.documentElement.clientHeight)
        })
        return () => Polaris.util.offResize(resizeID)
    })

    useEffect(() => {
        if (animated) {
            setTimeout(() => setAnimated(false), fadeDuration)
        }
    }, [animated])

    useEffect(() => {
        return () => {
            clearTimeout(timer.current)
        }
    }, [])


    return (
        <div className={styles.keyvisual}>
            <div className={styles.slide}>
                <ul>
                    {visuals.map((node, i) => (
                        <li key={i} style={wrapStyles[i]}>
                            <div className={styles.background}>
                                <div className={styles.roundbox}>
                                    <div style={backStyles[i]}>
                                        <Image className={styles.fullsize} imagePC={node.custom.visualPc} imageSP={node.custom.visualSp} />
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={styles.content}>
                <div className={styles.sticky} style={{ height: height }}>
                    <ul className={styles.links}>
                        {visuals.map((node, i) => (
                            <li key={i} style={itemStyles[i]}>
                                <Item show={dataShows[i]} node={node} />
                            </li>
                        ))}
                    </ul>
                    <ol className={styles.pager}>
                        {visuals.map((_, i) => (
                            <li key={i}>
                                <button aria-current={i === current} onClick={() => click(i)} aria-label={i + 1}></button>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default Keyvisual
